<!-- Generated by AIG Copilot - start -->
@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Arizona</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <h3 class="axis-h5">UM Coverage:</h3>
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <div class="axis-grid">
        @for (control of controls | slice: 2 : 7; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  (onSelect)="control.selectedPremium = $event.premium"
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.</span
                    >
                  }
                }
                @if (control.selectedPremium) {
                  <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
                }
              </div>
            </div>
          }
        }
      </div>
      <div class="axis-grid">
        @if ((baseRules?.["SplitMin_Uninsured_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[5].label }}</label>
              <div id="splitmin_uninsured_25k_50k-pdffield-arizona">{{ controls[5].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["CombinedSingleLimitMin_Uninsured_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[6].label }}</label>
              <div id="combinedsinglelimitmin_uninsured_50k-pdffield-arizona">{{ controls[6].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMLimit_Uninsured_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[4].label }}</label>
              <div id="um_uninsured_pdffield_arizona">{{ getLiabilityLimit }}</div>
            </div>
          </div>
        }
      </div>
      @if (controls?.length >= 8) {
        <h3 class="axis-h5">UIM Coverage:</h3>
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[7].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[7].formControlName)?.touched &&
              reactiveForm.get(controls[7].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[7].formControlName }}">
            @for (control of controls[7].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[7].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[7].formControlName)?.touched) {
            @if (reactiveForm.get(controls[7].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[8].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[8].formControlName)?.touched &&
            reactiveForm.get(controls[8].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 9) {
          <axis-radio-button-wrapper formControlName="{{ controls[8].formControlName }}">
            @for (control of controls[8].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[8].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[8].formControlName)?.touched) {
            @if (reactiveForm.get(controls[8].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>

      <div class="axis-grid">
        @for (control of controls | slice: 9; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  (onSelect)="control.selectedPremium = $event?.premium"
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.</span
                    >
                  }
                }
                @if (
                  control.selectedPremium !== undefined &&
                  control.selectedPremium !== null &&
                  control.selectedPremium !== ""
                ) {
                  <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
                }
              </div>
            </div>
          }
        }
      </div>
      <div class="axis-grid">
        @if ((baseRules?.["SplitMin_UnderInsured_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[12].label }}</label>
              <div id="splitmin_underinsured_25k_50k-pdffield-arizona">{{ controls[12].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["CombinedSingleLimitMin_UnderInsured_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[13].label }}</label>
              <div id="combinedsinglelimitmin_underinsured_50k-pdffield-arizona">{{ controls[13].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMLimit_UnderInsured_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[11].label }}</label>
              <div id="um_underinsured_pdffield_arizona">{{ getLiabilityLimit }}</div>
            </div>
          </div>
        }
      </div>
    </form>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Arizona</h2>
  @if (baseRules?.Reject_LevelOne_Uninsured_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Uninsured_Text }}
      </label>
    </div>
  }
  @if (baseRules?.Reject_LevelOne_UnderInsured_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_UnderInsured_Text }}
      </label>
    </div>
  }

  <!-- liability limit -->
  <div class="axis-grid">
    @if ((baseRules?.["LiabilityLimit_DropDown"] || "").includes("readonly")) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[14].label}}</label>
          <div>{{ controls[14].data[0].name }}</div>
        </div>
      </div>
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[15].label }}</label>
          <div>{{ controls[15].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
  
  <div class="axis-grid">
    @if (baseRules.BISplitMinLimits_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[12].label }} </label>
          <div>{{ controls[12].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules.BICombinedMinSingleLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[9].label }} </label>
          <div>{{ controls[9].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
  <div class="axis-grid">
    @for (control of controls | slice: 5; track $index) {
      @if (baseRules[control.baseRuleKey]?.includes("show")) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }} </label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>
}
